<template>
  <div class="commission custom-modal">
    <div class="custom-modal-header">
      <div class="title text-white">
        <loading-placeholder width="150px" />
      </div>
    </div>
    <div class="modal-body">
      <div class="d-flex" v-for="i in 4" :key="i">
        <div>
          <p><loading-placeholder width="120px" /></p>
          <h4><loading-placeholder width="80px" /></h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingPlaceholder from './shared/loading-placeholder'
export default {
  name: 'commission-loading',
  components: { LoadingPlaceholder }
}
</script>
